<template>
  <div
    :class="[
      orientationCustomize,
      alignVerticalCustomize,
      hasGrid ? gridCustomize : [xlGrid, lgGrid, mdGrid, smGrid],
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ontick-div",
  props: {
    orientation: {
      type: String,
      default: "vertical",
      validator: function (value) {
        return ["horizontal", "vertical"].indexOf(value) !== -1;
      },
    },
    alignVertical: {
      type: String,
      default: "start",
      validator: function (value) {
        return (
          ["start", "end", "center", "baseline", "stretch"].indexOf(value) !==
          -1
        );
      },
    },
    grid: {
      type: String,
    },
    xl: {
      type: String,
      default: "12",
    },
    lg: {
      type: String,
      default: "12",
    },
    md: {
      type: String,
      default: "12",
    },
    sm: {
      type: String,
      default: "12",
    },
  },
  computed: {
    orientationCustomize() {
      return {
        flex: this.orientation == "horizontal",
        block: this.orientation == "vertical",
      };
    },
    alignVerticalCustomize() {
      return {
        "items-start": this.alignVertical == "start",
        "items-end": this.alignVertical == "end",
        "items-center": this.alignVertical == "center",
        "items-baseline": this.alignVertical == "baseline",
        "items-stretch": this.alignVertical == "stretch",
      };
    },
    hasGrid() {
      return this.grid ? true : false;
    },
    gridCustomize() {
      return this.grid ? { [`col-span-${this.grid}`]: true } : {};
    },
    xlGrid() {
      return { [`xl:col-span-${this.lg}`]: true };
    },
    lgGrid() {
      return { [`lg:col-span-${this.lg}`]: true };
    },
    mdGrid() {
      return { [`md:col-span-${this.md}`]: true };
    },
    smGrid() {
      return { [`sm:col-span-${this.sm}`]: true };
    },
  },
};
</script>
